import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import PricingService from '../../../Services/PricingService';
import PricingCountrySelector from './PricingCountrySelector';
import PricingEditPanelDescription from './WindowDescription/PricingEditPanelDescription';
import PricingListItem from '../../../Domain/PricingListItem';
import PricingStatusChangeWindowDescription from './WindowDescription/PricingStatusChangeWindowDescription';
import PricingStatusChangeItem from '../../../Domain/PricingStatusChangeItem';
import EditAssignToWindowDescription from './WindowDescription/EditAssignToWindowDescription';
import PricingMultipleEditWindowDescription from './WindowDescription/PricingMultipleEditWindowDescription';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import PricingSearchParams from './PricingSearchParams';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import urlHelper from '../../../Helpers/urlHelper';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import PricingDetailMulitpleEditWindowDescription from './WindowDescription/PricingDetailMulitpleEditWindowDescription';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ManDayMultiUpdateWindowDescription from './WindowDescription/ManDayMultiUpdateWindowDescription';

export default class PricingAdmin extends Component
{
  static defaultProps = {
    Navigation: false,
  };

  constructor (props)
  {
    super(props);

    const searchItem = this.props.Navigation ? this.props.PricingSearchParams : new PricingSearchParams();

    this.state = {
      searchItem,
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
      pricingList: [],
      MultipleAction: [],
      isDetailsPage: window.location.href.includes('sales_pricing') || window.location.href.includes('servicedetails'),
      allItemsInTheSearchSetAreSelected: false,
    };

    this.refresh = this.refresh.bind(this);
    this.removePricing = this.removePricing.bind(this);
    this.handleExcelExportClick = this.handleExcelExportClick.bind(this);
    this.handleOpsExportClick = this.handleOpsExportClick.bind(this);
    PricingListItem.editFunction = this.editGeneralFunction.bind(this);
    PricingListItem.StatusChangeFunction = this.statusChangeFunction.bind(this);
    PricingListItem.clickOnSelect = this.clickOnSelect.bind(this);
    PricingListItem.clickOnGlobalSelect = this.selectAllElement.bind(this);
    PricingListItem.selectedStatus = this.selectedStatus.bind(this);
  }

  editGeneralFunction (id, item)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.Edit,
      selectedItem: item,
    });
  }

  statusChangeFunction (id, item)
  {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  renderButtonsAndPanels ()
  {
    const selected = this.state.pricingList.filter((x) => x.Selected === true);
    const numberOfSelectedElement = selected.length;

    const href =
      this.state.searchItem.OpportunityId !== undefined && this.state.searchItem.OpportunityId !== ''
        ? urlHelper.getProperUrl('sales_pricing/search', `OpportunityId=${this.state.searchItem.OpportunityId}`)
        : urlHelper.getProperUrl('sales_pricing/search', `ServiceId=${this.state.searchItem.ServiceId}`);

    const statusIsDisabled = this.StatusIsDisabled();
    return (
      <>
        <FigmaButtonRow
          className={this.state.isDetailsPage ? 'MenuButtonList' : 'InnerMenuButtonFigmaList'}
          buttons={this.getButtonDescription(href, numberOfSelectedElement, statusIsDisabled, selected)}
        />
        {this.renderPanels()}
      </>
    );
  }

  getButtonDescription (href, numberOfSelectedElement, statusIsDisabled, selected)
  {
    return [
      {
        iconName: 'fa-solid fa-circle-info',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Secondary,
        iconPosition: IconPositionEnum.Center,
        tooltip: 'Pricing list',
        disabled: !this.props.Navigation,
        hidden: !this.props.Navigation,
        href,
      },
      {
        iconName: 'fa-solid fa-rectangle-history-circle-plus',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: () => this.MultiplePricingUpdate(),
        disabled: numberOfSelectedElement === 0 || statusIsDisabled || this.hasUneditableTypesSelected(selected, false),
        tooltip: 'Pricing Multiple Update',
        roleKey: 'opportunity_edit',
      },
      {
        iconName: 'fa-solid fa-money-check-dollar-pen',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: () => this.MultiplePricingDetailUpdate(),
        disabled:
          numberOfSelectedElement === 0 ||
          statusIsDisabled ||
          !this.SameCurrency() ||
          this.hasUneditableTypesSelected(selected, true),
        tooltip: 'Pricing Detail Multi Update',
        roleKey: 'opportunity_edit',
      },
      {
        iconName: 'fa-solid fa-calendar-users',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: () => this.ManDayMultiUpdate(),
        disabled: numberOfSelectedElement === 0 || statusIsDisabled || this.hasUneditableTypesSelected(selected, true),
        tooltip: 'ManDay Multi Update',
        roleKey: 'opportunity_edit',
      },
      {
        iconName: 'fa-solid fa-trash-can',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        tooltip: 'Remove',
        onClick: () => ErrorMessage.SetApprove('Are you sure you want to delete?', this.removePricing),
        disabled: this.validateForRemovePricing() || statusIsDisabled,
        roleKey: 'opportunity_edit',
      },
      {
        iconName: 'fa-solid fa-user-pen',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        tooltip: 'Assign to',
        onClick: () => this.assignPricing(),
        disabled: numberOfSelectedElement === 0 || statusIsDisabled,
        roleKey: 'opportunity_edit',
      },
      {
        iconName: 'fa-solid fa-file-excel',
        type: ButtonTypeEnum.NormalIconOnly,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.Center,
        onClick: () => this.handleExcelExportClick(),
        disabled: numberOfSelectedElement === 0 || (!this.props.TypeName && this.state.searchItem.ServiceId == null),
        tooltip: 'Export Excel based on selected items',
        roleKey: 'reports_pricingexport',
      },
      {
        label: 'Pricing Export (Ops)',
        type: ButtonTypeEnum.NormalNormal,
        color: ButtonColorsEnum.Common,
        iconPosition: IconPositionEnum.None,
        onClick: () => this.handleOpsExportClick(),
        disabled: numberOfSelectedElement === 0,
        hidden: !this.state.searchItem.OpportunityId,
        tooltip: 'Pricing Export (Ops)',
        roleKey: 'exceldataexport',
      },
      this.props.Navigation
        ? {
          iconName: 'fa-solid fa-refresh',
          type: ButtonTypeEnum.NormalIconOnly,
          color: ButtonColorsEnum.Common,
          iconPosition: IconPositionEnum.Center,
          onClick: () => this.refresh(true),
          //disabled: statusIsDisabled,
          tooltip: 'Refresh',
        }
        : null,
      {
        iconName: 'fa-solid fa-plus-circle',
        label: 'Create',
        type: ButtonTypeEnum.NormalIconRight,
        color: ButtonColorsEnum.Primary,
        iconPosition: IconPositionEnum.Left,
        tooltip: 'Create New Pricing',
        onClick: () => this.AddNewItem(true),
        hidden: statusIsDisabled || !this.state.searchItem.ServiceId,
        roleKey: 'opportunity_edit',
      },
    ];
  }

  clickOnSelect (item, selected)
  {
    item.Selected = selected;
    const templist = [ ...this.state.pricingList ];
    templist.find((c) => c.PricingId === item.PricingId).Selected = selected;
    this.setState({ pricingList: [ ...templist ] });
  }

  selectAllElement = () =>
  {
    const selectedStatus = this.state.pricingList.some((item) => item.Selected === false);
    const templist = [ ...this.state.pricingList ];
    templist.forEach((c) =>
    {
      c.Selected = selectedStatus;
    });

    this.setState({ pricingList: [ ...templist ] });
  };

  selectedStatus = () =>
  {
    if (this.state.pricingList.some((x) => x.Selected === false)) return false;

    return true;
  };

  refresh = (clearCache) =>
  {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      searchItem: { ...this.state.searchItem },
      forceClearCache: clearCache,
    });
  };

  componentDidUpdate (prevProps)
  {
    if (this.props.PricingSearchParams !== prevProps.PricingSearchParams)
    {
      this.setState({ searchItem: { ...this.props.PricingSearchParams } });
    }
  }

  validateForRemovePricing ()
  {
    const selectedElements = this.state.pricingList.filter((x) => x.Selected === true);

    if (selectedElements.length === 0) return true;

    if (selectedElements.some((item) => item.StatusCode === 5)) return true;

    return false;
  }

  removePricing = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const data = {
      Action: 'MultipleRemove',
      Pricings: list,
      AllItemsInTheSearchSetAreSelected: this.state.allItemsInTheSearchSetAreSelected,
      ServiceId: this.state.searchItem.ServiceId,
      OpportunityId: this.state.searchItem.OpportunityId,
    };
    PricingService.MultiplePost(data)
      .then(() =>
      {
        this.refresh(false);
      })
      .catch(() =>
      {
        ErrorMessage.SetErrorMessage('PA226');
      });
  };

  handleExcelExportClick = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const selectedItemIds = list.map((item) => item.PricingId);

    PricingService.ExportAdminExcelAsync(
      selectedItemIds,
      this.props.TypeName ? this.props.TypeName : 'PricingOpportunityFieldWorkOfficeItem',
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem
    ).catch(() => ErrorMessage.SetErrorMessage('PA248'));
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  };

  handleOpsExportClick = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const selectedItemIds = list.map((item) => item.PricingId);

    PricingService.ExportPricingForOps(
      this.state.searchItem,
      selectedItemIds,
      this.state.allItemsInTheSearchSetAreSelected
    ).catch(() => ErrorMessage.SetErrorMessage('PA294'));

    ErrorMessage.SetSuccess('The Pricing Export (Ops) has started.');
  };

  assignPricing = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const data = {
      Action: 'MultipleAssignTo',
      Pricings: list,
    };

    this.setState({
      MultipleAction: data,
      shownPanel: ShownPanelsEnum.EditSubItem,
    });
  };

  AddNewItem = () =>
  {
    this.setState({ shownPanel: ShownPanelsEnum.AddNewItem });
  };

  MultiplePricingUpdate = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const data = {
      Action: 'MultiplePricingUpdate',
      Pricings: list,
      EditingApprovedPricings: this.onlyHasApproved(list),
    };

    this.setState({
      MultipleAction: data,
      shownPanel: ShownPanelsEnum.MultiEdit,
    });
  };

  MultiplePricingDetailUpdate = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const data = {
      Action: 'MultiplePricingDetailUpdate',
      Pricings: list,
    };

    this.setState({
      MultipleAction: data,
      shownPanel: ShownPanelsEnum.MassUpload,
    });
  };

  ManDayMultiUpdate = () =>
  {
    const list = this.state.pricingList.filter((x) => x.Selected === true);
    const data = {
      Action: 'ManDayMultiUpdate',
      Pricings: list,
    };

    this.setState({
      MultipleAction: data,
      shownPanel: ShownPanelsEnum.SomethingElse,
    });
  };

  renderPanels ()
  {
    switch (this.state.shownPanel)
    {
      case ShownPanelsEnum.AddNewItem: {
        return (
          <PricingCountrySelector
            clickOnCancel={() =>
            {
              this.setState({ shownPanel: ShownPanelsEnum.None });
              this.refresh(false);
            }}
            ServiceId={this.state.searchItem.ServiceId}
            clickOnSave={() => this.refresh(false)}
          />
        );
      }

      case ShownPanelsEnum.EditSubItem: {
        const tempMultipleAction = this.state.MultipleAction;
        tempMultipleAction.AllItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
        tempMultipleAction.ServiceId = this.state.searchItem.ServiceId;
        tempMultipleAction.OpportunityId = this.state.searchItem.OpportunityId;

        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditAssignToWindowDescription}
            editedItem={tempMultipleAction}
            errorCode='PA276'
          />
        );
      }

      case ShownPanelsEnum.MultiEdit: {
        const tempMultipleAction = this.state.MultipleAction;
        tempMultipleAction.NumEvalsPerCycle = '';
        tempMultipleAction.MarkUpPct = '';
        tempMultipleAction.StatusCode = '';
        tempMultipleAction.OfficeId = '';
        tempMultipleAction.CurrencyId = '';
        tempMultipleAction.RoundFee = '';
        tempMultipleAction.MysteryShoppingSystemId = '';
        tempMultipleAction.CallRecordingCostId = '';
        tempMultipleAction.CsatcostId = '';
        tempMultipleAction.IvrcostId = '';
        tempMultipleAction.AllItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
        tempMultipleAction.ServiceId = this.state.searchItem.ServiceId;
        tempMultipleAction.OpportunityId = this.state.searchItem.OpportunityId;

        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={PricingMultipleEditWindowDescription}
            editedItem={tempMultipleAction}
            errorCode='PA297'
          />
        );
      }

      default:
        return null;
    }
  }

  StatusIsDisabled ()
  {
    if (this.state.pricingList.length > 0)
    {
      return (
        this.state.pricingList[ 0 ].OpportunityStatusCode === 11 || this.state.pricingList[ 0 ].OpportunityStatusCode === 12
      );
    }
    return false;
  }

  onlyHasApproved = (selected) =>
  {
    return (
      selected.filter((x) => x.StatusCode.toString() === '5').length > 0 &&
      selected.filter((x) => x.StatusCode.toString() !== '5').length === 0
    );
  };

  hasUneditableTypesSelected = (selected, checkForApproved) =>
  {
    return (
      selected.filter((x) => checkForApproved && x.StatusCode.toString() === '5').length > 0 ||
      selected.filter((x) => x.StatusCode.toString() === '7').length > 0
    );
  };

  SameCurrency ()
  {
    const selected = this.state.pricingList.filter((x) => x.Selected === true);
    if (selected.length > 0)
    {
      const currencyId = selected[ 0 ].CurrencyId;
      return selected.every((item) => item.CurrencyId === currencyId);
    }
    return false;
  }

  onChangeEditedItem (item)
  {
    //console.log(item);
  }

  renderOverWindows ()
  {
    switch (this.state.shownPanel)
    {
      case ShownPanelsEnum.Edit: {
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() =>
            {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSave={() => this.refresh(false)}
            windowDescription={PricingEditPanelDescription}
            onChangeEditedItem={(item) => this.onChangeEditedItem(item)}
            editedItem={this.state.selectedItem}
            errorCode={'PA335'}
          />
        );
      }

      case ShownPanelsEnum.MassUpload: {
        const tempMultipleAction = this.state.MultipleAction;
        tempMultipleAction.ClientFeePerEval = '';
        tempMultipleAction.EvalFeePerEval = '';
        tempMultipleAction.EditorCostPerEval = '';
        tempMultipleAction.SMCostPerEval = '';

        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={PricingDetailMulitpleEditWindowDescription}
            editedItem={tempMultipleAction}
            errorCode='PA343'
          />
        );
      }

      case ShownPanelsEnum.SomethingElse: {
        const tempMultipleAction = this.state.MultipleAction;
        tempMultipleAction.ClientFeePerEval = '';
        tempMultipleAction.EvalFeePerEval = '';
        tempMultipleAction.EditorCostPerEval = '';
        tempMultipleAction.AllItemsInTheSearchSetAreSelected = this.state.allItemsInTheSearchSetAreSelected;
        tempMultipleAction.ServiceId = this.state.searchItem.ServiceId;
        tempMultipleAction.OpportunityId = this.state.searchItem.OpportunityId;

        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={ManDayMultiUpdateWindowDescription}
            editedItem={tempMultipleAction}
            errorCode='PA405'
          />
        );
      }

      case ShownPanelsEnum.StatusUpdate: {
        const tempStatusChangeItem = new PricingStatusChangeItem(this.state.selectedItem);
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            clickOnCancel={() =>
            {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSave={() => this.refresh(false)}
            windowDescription={PricingStatusChangeWindowDescription}
            editedItem={tempStatusChangeItem}
            approveBeforeSaveCheck={PricingStatusChangeWindowDescription.warningCondition}
            approveBeforeSaveMessage={PricingStatusChangeWindowDescription.warningMessage}
            errorCode='PA357'
          />
        );
      }

      default:
        return null;
    }
  }

  render ()
  {
    return (
      <div
        className='contentwrapper'
        style={this.props.Navigation ? {} : { position: 'relative' }}
      >
        {this.renderButtonsAndPanels()}
        {this.renderOverWindows()}
        <TabOfDataTable
          type={this.props.Type === undefined ? PricingListItem : this.props.Type}
          serviceFunction={PricingService.GetPricingItemList}
          convertDBItemsFunction={PricingService.ConvertDBItem}
          searchItem={this.state.searchItem}
          searchParamsType={PricingSearchParams}
          showSearchStrip={!this.props.Navigation}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) =>
          {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          ModalFeature={this.props.Navigation}
          changeOfItemListFunction={(itemList) => this.setState({ pricingList: itemList, forceClearCache: false })}
          forceClearCacheOnSearch={this.state.forceClearCache}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in ids or names...'
          errorCode='PA381'
        />
      </div>
    );
  }
}
